import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BreadcrumbCandidateDetails from '@/components/molecules/onboarding-management/BreadcrumbCandidateDetails';
import CandidateDetails from '@/components/organisms/onboarding-management/CandidateDetails';

const ManagementOnboardingCandidateDetails = () => {
    const navigate = useNavigate();
    const { candidateUuid } = useParams();

    return (
        <div className="h-full min-h-0 flex flex-col gap-secondDegree ">

            <div className="min-h-0 flex-1 rounded-sm   overflow-hidden flex flex-col gap-firstDegree">
                <div className="shrink-0">
                    <BreadcrumbCandidateDetails />
                </div>

                <div className="min-h-0 flex-1">
                    <CandidateDetails candidateUuid={candidateUuid} />
                </div>
            </div>
        </div>
    );
};

export default ManagementOnboardingCandidateDetails;
